import React, {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField} from "@mui/material";
import {toast} from "react-toastify";
import {AmiRepository} from "../../../../repositories/AmiRepository";
import {varsListToObject, VariablesEditor} from "./VariablesEditor";

export const AddExtensionModal = ({open, flowUid, handleClose, onCreated}) => {
  const [extensionNumber, setExtensionNumber] = useState("");
  const [description, setDescription] = useState("");
  const [varRows, setVarRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setExtensionNumber("");
      setDescription("");
      setVarRows([
        {key: "FLOW_UID", value: flowUid || ""},
        {key: "AUDIOSOCKET_HOST", value: "localhost:9098"},
        {key: "BEEP_SIGNAL", value: "false"},
        {key: "SEGMENT", value: "prepaid"},
      ]);
    }
  }, [open, flowUid]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await AmiRepository.registerExtension(flowUid, {
        extension: extensionNumber.trim() || undefined,
        flow_uid: flowUid,
        description: description.trim() || undefined,
        variables: varsListToObject(varRows),
      });
      toast.success(`Extension ${response?.data?.extension || ""} created`);
      if (response?.data?.conf_regenerated === false) {
        toast.error(response?.data?.conf_error || "Configuration file failed to regenerate");
      }
      onCreated?.(response?.data);
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to create extension");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: handleSubmit,
        sx: {minWidth: "360px", maxWidth: "sm", borderRadius: 4, p: 2, width: "100%"},
      }}
    >
      <DialogTitle>Add Extension</DialogTitle>
      <DialogContent sx={{display: "flex", flexDirection: "column", gap: 2, py: "16px !important"}}>
        <TextField
          label="Extension Number" fullWidth
          value={extensionNumber} onChange={(e) => setExtensionNumber(e.target.value)}
          placeholder="e.g. 950002"
          helperText="Leave empty to auto-assign the next free slot in this flow's block"
        />
        <TextField
          label="Description" fullWidth
          value={description} onChange={(e) => setDescription(e.target.value)}
          placeholder="e.g. Support bot"
        />
        <VariablesEditor rows={varRows} onChange={setVarRows}/>
      </DialogContent>
      <DialogActions sx={{px: 2, py: 1}}>
        <Button variant="ghost" onClick={handleClose} disabled={loading}>Cancel</Button>
        <Button type="submit" variant="modal" disabled={loading}>
          {loading ? "Creating..." : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
